const TRIGGER_POINT_RATIO = 0.75;

export default () => ({
    activeTab: 0,
    observers: [],
    rootElement: null,
    scrollHandler: null,

    setActiveTab(index) {
        if (this.activeTab === index) return

        this.activeTab = index
        this.cleanupObservers()

        this.initializeTimeline()
    },

    goNextTab() {
        const tabs = this.getTabElements()
        if (!tabs.length || this.activeTab >= tabs.length - 1) return

        this.navigateToTab(this.activeTab + 1, tabs)
    },

    goPrevTab() {
        const tabs = this.getTabElements()
        if (!tabs.length || this.activeTab <= 0) return

        this.navigateToTab(this.activeTab - 1, tabs)
    },

    navigateToTab(tabIndex, tabs) {
        this.setActiveTab(tabIndex)

        tabs.forEach((tab, index) => {
            tab.classList.toggle('m-is-active', index === tabIndex)
        })

        console.log({
            top: this.rootElement.getBoundingClientRect().top,
            scry: window.scrollY,
            res: this.rootElement.getBoundingClientRect().top + window.scrollY + 350,
        })

        window.scrollTo({
            top: this.rootElement.getBoundingClientRect().top + window.scrollY - 160,
            behavior: 'smooth',
        })
    },

    getTabElements() {
        const root = this.getRootElement()
        return root ? root.querySelectorAll('.c-timeline-tabs .c-timeline-tab') : []
    },

    cleanupObservers() {
        if (this.observers.length) {
            this.observers.forEach((observer) => {
                if (observer && observer.disconnect) {
                    observer.disconnect()
                }
            })
            this.observers = []
        }

        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler)
            this.scrollHandler = null
        }
    },

    getRootElement() {
        if (this.rootElement) return this.rootElement

        if (this.$el.classList.contains('c-timeline')) {
            this.rootElement = this.$el
        } else {
            this.rootElement = this.$el.closest('.c-timeline') || document.querySelector('.c-timeline')
        }

        return this.rootElement
    },

    initializeTimeline() {
        const root = this.getRootElement()
        if (!root) return

        const timelineContent = root.querySelector(`.c-timeline-content[data-tab="${this.activeTab}"]`)
        if (!timelineContent) return

        const line = timelineContent.querySelector('.c-line')
        if (!line) return

        const rows = timelineContent.querySelectorAll('.c-row')
        if (!rows.length) return

        const firstRow = rows[0]
        const lastRow = rows[rows.length - 1]

        const updateLineHeight = () => {
            if (!firstRow || !lastRow) return

            const firstRowRect = firstRow.getBoundingClientRect()
            const lastRowRect = lastRow.getBoundingClientRect()
            const lineHeight = lastRowRect.bottom - firstRowRect.top

            if (lineHeight > 0) {
                line.style.height = `${lineHeight}px`
            }
        }

        updateLineHeight()

        const handleScroll = () => {
            requestAnimationFrame(() => {
                if (timelineContent.offsetParent === null) return

                updateLineHeight()

                const windowHeight = window.innerHeight
                const triggerPoint = windowHeight * TRIGGER_POINT_RATIO
                let progress = this.calculateProgress(firstRow, lastRow, triggerPoint)

                line.style.setProperty('--line-progress', progress)

                this.updateRowVisibility(rows, firstRow, lastRow, progress)
            })
        }

        this.scrollHandler = handleScroll
        window.addEventListener('scroll', this.scrollHandler)
        handleScroll()

        const resizeObserver = new ResizeObserver(() => {
            updateLineHeight()
            handleScroll()
        })

        resizeObserver.observe(document.body)
        this.observers.push(resizeObserver)
    },

    updateRowsWithVisibilityThreshold(rows, visibleThreshold = 200) {
        const viewportHeight = window.innerHeight

        rows.forEach((row) => {
            const rowRect = row.getBoundingClientRect()

            const visibleTop = Math.max(0, -rowRect.top)
            const visibleBottom = Math.max(0, rowRect.bottom - viewportHeight)
            const rowHeight = rowRect.height
            const visibleHeight = rowHeight - visibleTop - visibleBottom

            row.classList.toggle('m-is-on-screen', visibleHeight >= visibleThreshold)
        })
    },

    calculateProgress(firstRow, lastRow, triggerPoint) {
        if (!firstRow || !lastRow) return 0

        const firstRowTop = firstRow.getBoundingClientRect().top
        const lastRowBottom = lastRow.getBoundingClientRect().bottom
        const totalDistance = lastRowBottom - firstRowTop

        if (totalDistance <= 0) return 0

        const scrolledDistance = triggerPoint - firstRowTop
        let progress = scrolledDistance / totalDistance

        return Math.max(0, Math.min(1, progress))
    },

    updateRowVisibility(rows, firstRow, lastRow, progress) {
        const firstRowTop = firstRow.getBoundingClientRect().top
        const lastRowBottom = lastRow.getBoundingClientRect().bottom

        if (this.$store.app.isMobile) {
            this.updateRowsWithVisibilityThreshold(rows)
        } else
            rows.forEach((row) => {
                const stop = row.querySelector('.c-line-stop')
                if (!stop) return

                const stopRect = stop.getBoundingClientRect()
                const stopCenter = stopRect.top + stopRect.height / 2
                const stopPosition = (stopCenter - firstRowTop) / (lastRowBottom - firstRowTop)

                row.classList.toggle('m-is-on-screen', progress >= stopPosition)
            })
    },

    init() {
        this.initializeTimeline()
    },

    destroy() {
        this.cleanupObservers()
    },
})
